import * as React from 'react';
import { Route, useLocation } from 'react-router-dom';
import qs from 'query-string';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';

import { Menu, Footer } from '@pm/gui';

import { Container } from '../ui/Container';
import { Heading } from '../ui/Heading';
import { Paragraph } from '../ui/Paragraph';
import { FadeInBackground } from '../ui/FadeInBackground';

import { Seo } from '../utils/Seo';
import { useFadeTransition } from '../utils/hooks/useFadeTransition';

import { theme } from '../../../client/theme/thems/nybygg_dark_old';
import { GlobalStyles } from '../../../client/GlobalStyles';
import { useApolloClient } from '@apollo/client';

const Status: React.FC<{ code: number; location: any }> = ({
  code,
  location,
  children,
}) => {
  return (
    <Route
      render={({ staticContext }: any) => {
        if (staticContext) {
          staticContext.status = code;
          staticContext.pathname = location?.pathname
            ? location.pathname
            : null;
        }
        return children;
      }}
    />
  );
};

const ServerError: React.FC = () => {
  const location = useLocation();
  const client = useApolloClient();
  const queryString = location.search ? qs.parse(location.search) : null;

  const { fadeIn: pageFadeIn } = useFadeTransition({
    immidiate: true,
  });

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <NoMatchGlobalStyles />
      <Seo title="Noe gikk galt - PrivatMegleren" description="" />
      <Menu client={client} />
      <Status code={500} location={location}>
        <Container
          style={{
            paddingTop: '150px',
            minHeight: '800px',
            ...pageFadeIn,
          }}
        >
          <Heading tag="h1" center={true}>
            Oi, noe gikk galt
          </Heading>
          <Paragraph center={true}>Vennligst forsøk igjen.</Paragraph>
          <Paragraph center={true}>
            <a
              href={`https://privatmegleren.no${
                queryString && queryString['?url']
              }`}
            >
              https://privatmegleren.no
              {queryString && queryString['?url']}
            </a>
          </Paragraph>
          <FadeInBackground
            opacity={0.5}
            position="center -175px"
            url="https://cdn.reeltime.no/pm_assets/img/bakgrunner/hjort_bakside2.jpg"
          />
        </Container>
      </Status>
      <Footer />
    </ThemeProvider>
  );
};

export default ServerError;

const NoMatchGlobalStyles = createGlobalStyle`
  body, html {
    margin: 0;
    padding: 0;
  }

  body {
    background: #000;
  }

  h1, h2, h3, h4, h5, h6 {
    color: #e8c893;
  }

  h1 {
    font-size: 48px;
    font-weight: 400;
  }

  p {
    color: #fff;
  }

  a {
    color: #e8c893;
  }
`;
